import { render } from "./toast.vue?vue&type=template&id=1087ac7e"
import script from "./toast.vue?vue&type=script&lang=js"
export * from "./toast.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__